/**
 * Reads the signed-in user's auth token from the persisted session.
 *
 * The session is stored as a JSON object under `safaqat24.auth.session`
 * (see useAuth + utils/sessionPersistence), with the bearer token nested
 * inside it. Services must NOT read a bare `safaqat24.auth.token` key —
 * login never writes one, so that always yields '' and authenticated
 * requests go out with no Authorization header (→ 401).
 */
const SESSION_STORAGE_KEY = 'safaqat24.auth.session';

export function getAuthToken(): string {
  try {
    if (typeof window === 'undefined') return '';
    const raw = window.localStorage.getItem(SESSION_STORAGE_KEY);
    if (!raw) return '';
    const session = JSON.parse(raw) as { token?: string } | null;
    return session?.token ?? '';
  } catch {
    return '';
  }
}
